// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterDiv {
    /* width: 100%; */
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 20px;
    padding: 10px;
    flex-wrap: wrap;
}

.datepickerdiv {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap; 
}
.header-div{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media (max-width: 1200px) {
    .filterDiv {
        justify-content: start; 
    }

    .datepickerdiv {
        flex-direction: column;
        align-items: stretch;
    }

    .datepickerdiv div {
        width: 100%;
        margin-bottom: 5px; 
    }

    .btnReport {
        width: 40%;
        margin-top: 10px;
    }
}

@media (max-width: 768px) {
    .filterDiv {
        justify-content: start;
        gap: 10px;
    }

    .datepickerdiv {
        flex-direction: column;
        width: 100%;
        gap: 0px;
    }
    .header-div{
        flex-direction: column;
        align-items: start;
    }
    .header-div > .btnReport {
        margin: 10px;
        margin-top: 0px;
        padding: 12px;
        width: 50%;
    }
    .css-1b1fjlj-MuiFormControl-root-MuiTextField-root{
        width: 100%;
        z-index: 0;
    }
    .css-1xp5r68-MuiFormControl-root-MuiTextField-root{
        width: 100%;
        margin-top: -14px !important;
    }
    .datepickerdiv div {
        width: 100%;
    }

    .btnReport {
        width: 100%;
        margin-top: 10px;
        padding: 12px;
    }

    .filterDiv > div {
        width: 100%;
    }

    .filterDiv > div select {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .filterDiv {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .css-1b1fjlj-MuiFormControl-root-MuiTextField-root{
        width: 100%;
        z-index: 0;
    }
    .css-1xp5r68-MuiFormControl-root-MuiTextField-root{
        width: 100%;
        margin-top: -14px !important;
    }
    .datepickerdiv {
        flex-direction: column;
        width: 100%;
        gap: 0px;
    }

    .datepickerdiv div {
        width: 100%;
    }

    .btnReport {
        width: 100%;
        margin-top: 10px;
        padding: 12px;
    }

    .filterDiv > div {
        width: 100%;
    }

    .filterDiv > div select {
        width: 100%;
    }

    .filterDiv > div select, .filterDiv > div input {
        padding: 12px;
    }
}



.css-1tlcqt-MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input{
    min-width: 200px !important;
}

.css-bmnu5q-MuiTableCell-root{
    /* padding: 2px 16px !important; */
    /* height: 0px !important; */
}`, "",{"version":3,"sources":["webpack://./src/live-tracking/components/punctualityreport/punctuality.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,QAAQ;IACZ;IACA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,eAAe;QACf,aAAa;QACb,UAAU;IACd;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,4BAA4B;IAChC;IACA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,4BAA4B;IAChC;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;;;AAIA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC","sourcesContent":[".filterDiv {\n    /* width: 100%; */\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 20px;\n    padding: 10px;\n    flex-wrap: wrap;\n}\n\n.datepickerdiv {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap; \n}\n.header-div{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n@media (max-width: 1200px) {\n    .filterDiv {\n        justify-content: start; \n    }\n\n    .datepickerdiv {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .datepickerdiv div {\n        width: 100%;\n        margin-bottom: 5px; \n    }\n\n    .btnReport {\n        width: 40%;\n        margin-top: 10px;\n    }\n}\n\n@media (max-width: 768px) {\n    .filterDiv {\n        justify-content: start;\n        gap: 10px;\n    }\n\n    .datepickerdiv {\n        flex-direction: column;\n        width: 100%;\n        gap: 0px;\n    }\n    .header-div{\n        flex-direction: column;\n        align-items: start;\n    }\n    .header-div > .btnReport {\n        margin: 10px;\n        margin-top: 0px;\n        padding: 12px;\n        width: 50%;\n    }\n    .css-1b1fjlj-MuiFormControl-root-MuiTextField-root{\n        width: 100%;\n        z-index: 0;\n    }\n    .css-1xp5r68-MuiFormControl-root-MuiTextField-root{\n        width: 100%;\n        margin-top: -14px !important;\n    }\n    .datepickerdiv div {\n        width: 100%;\n    }\n\n    .btnReport {\n        width: 100%;\n        margin-top: 10px;\n        padding: 12px;\n    }\n\n    .filterDiv > div {\n        width: 100%;\n    }\n\n    .filterDiv > div select {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .filterDiv {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    .css-1b1fjlj-MuiFormControl-root-MuiTextField-root{\n        width: 100%;\n        z-index: 0;\n    }\n    .css-1xp5r68-MuiFormControl-root-MuiTextField-root{\n        width: 100%;\n        margin-top: -14px !important;\n    }\n    .datepickerdiv {\n        flex-direction: column;\n        width: 100%;\n        gap: 0px;\n    }\n\n    .datepickerdiv div {\n        width: 100%;\n    }\n\n    .btnReport {\n        width: 100%;\n        margin-top: 10px;\n        padding: 12px;\n    }\n\n    .filterDiv > div {\n        width: 100%;\n    }\n\n    .filterDiv > div select {\n        width: 100%;\n    }\n\n    .filterDiv > div select, .filterDiv > div input {\n        padding: 12px;\n    }\n}\n\n\n\n.css-1tlcqt-MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input{\n    min-width: 200px !important;\n}\n\n.css-bmnu5q-MuiTableCell-root{\n    /* padding: 2px 16px !important; */\n    /* height: 0px !important; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
